// Text several marketing pages share: the social proof above the heroes, the logos
// and the FAQ heading.
export const common = {
  statClips: "8.5M clips",
  statMadeBy: " made by ",
  statCreators: "3.5M creators",
  trustedBy: "Trusted by ",
  happyUsers: "{count} happy users",
  userAlt: "Klap user",
  usedBy: "Used by teams at",
  faqTitle: "Frequently Asked Questions",
  demoAlt: "Klap demo",
  personasLabel: "Personas",
};
